module.exports = __webpack_public_path__ + "static/media/regiless_user_onboarding_03_2x.059682cd.png";